import { useContext, useEffect, useState, useRef } from "react";
import "./_style.scss";
import { useLocation, useNavigate } from "react-router-dom";
import { GlobalContext } from "../../context/globalContext";
import { BusinessContext } from "../../context/businessContext";
import { fakeTableList, headList, schema } from "./parts";
import TkInfoManual from "../../components/atoms/TkInfoManual";
import TkFakeTable from "../../components/molecules/TkFakeTable";
import { Box, Typography } from "@mui/material";
import TkBackButton from "../../components/molecules/TkBackButton";
import TkMemo from "../../components/molecules/TkMemo";
import TkApprovalDateSymbolNumberRegistrationDialog from "../../components/molecules/TkApprovalDateSymbolNumberRegistrationDialog";
import TkViewButtonJudgement from "../../components/molecules/TkViewButtonJudgement";
import { labelids } from "../../assets/data/TkExplanationProperty";
import TkKikoStepper from "../../components/molecules/TkKikoStepper";
import { ITkViewButtonJudgementStatus } from "../../type/componentsType/TkViewButtonJudgement";
import TkTableWithNoLine from "../../components/molecules/TkTableWithNoLine";
import TkDownloadLink from "../../components/atoms/TkDownloadLink";
import { IAPI_APP016_Request, IAPI_CON006_Response } from "../../type/apiType";
import { httpAPI_APP016, httpAPI_CON006 } from "./api/request";
import TkContractorAndNumberLine from "../../components/molecules/TkContractorAndNumberLine";
import {
  applyEvent,
  CommonOrCommonRetirementFlug,
  FormClassApply,
  NoOwnerReason,
} from "../../assets/data/Constants";
import { TkGetCode } from "../../utils/TkGetCode";
import _ from "lodash";
import { isStatusAfterApproval } from "../../utils/useTools";
import TkButton from "../../components/atoms/TkButton";

/**
 * SCRW050001 契約解除（経営者でなくなった）入力内容確認
 * @return SCRW050001
 */
const SCRW050001 = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const { state, setState } = useContext(GlobalContext);
  const { state: businessState } = useContext(BusinessContext);

  const [responseData, setResponseData] = useState<IAPI_CON006_Response>({});
  const [stateTableList, setStateTableList] = useState<any>([]);
  const [isOpen, setIsOpen] = useState(false);
  const [bodyList, setBodyList] = useState<any>();
  const [fileList, setFileList] = useState<any[]>([]);
  const [memoData, setMemoData] = useState("");
  const [memoCheck, setMemoCheck] = useState(false);
  const [workFlow, setWorkFlow] = useState(false);

  const stateFakeTableListRef = useRef(_.cloneDeep(fakeTableList));
  const stateFakeTableList = stateFakeTableListRef.current;

  const formatFileList = (
    fileList: any[],
    symbolNo: string,
    decisionDate: string
  ) => {
    return fileList.map((item) => [
      {
        children: (
          <TkDownloadLink
            dataname={TkGetCode(FormClassApply, item?.formClass)}
            base64filedata={item.fileBase64}
            downloadBase64={true}
          />
        ),
        width: "50%",
      },
      {
        children: symbolNo,
      },
      {
        children: decisionDate,
      },
    ]);
  };

  // 初期表示
  useEffect(() => {
    handleInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleInit = async () => {
    try {
      const res = await httpAPI_CON006({
        applyId: location.state?.applyId ?? businessState.job_02?.applyId,
      });

      if (res.resultCd === "I0000") {
        let resArr = stateFakeTableList;

        setResponseData(res);

        const bodyListData = res.statusList?.map((item) => [
          { children: item.managerName },
          { children: item.process },
          { children: item.createDate, align: "center" },
          { children: item.processComment },
        ]);
        setBodyList(bodyListData ?? []);

        let noOwnerDate = resArr.find(
          (item) => item.keyword === "noOwnerDate"
        )!;
        noOwnerDate.text = res.noOwnerDate;

        let noOwnerReason = resArr.find(
          (item) => item.keyword === "noOwnerReason"
        )!;
        noOwnerReason.text =
          res.noOwnerReason +
          "　" +
          TkGetCode(NoOwnerReason, res.noOwnerReason);

        let reason = resArr.find((item) => item.keyword === "reason")!;
        reason.text = res.reason;

        const fileList: any[] = [];
        let symbolNo = "";
        let decisionDate = "";

        // 廃止・休止が確認できる書類
        let downloadLink = resArr.find(
          (item) => item.keyword === "downloadLink"
        )!;
        res.formList?.forEach((item) => {
          if (item.formClass === "6") {
            downloadLink.base64filedata = item.fileBase64;
            downloadLink.dataname = item.fileName;
          } else if (item.formClass === "EXP0601011") {
            fileList.push(item);
          }
        });

        if (isStatusAfterApproval(res.latestApplyStatus)) {
          symbolNo = res.symbolNo ?? "";
          decisionDate = res.decisionDate ?? "";
        }
        setFileList(formatFileList(fileList, symbolNo, decisionDate));

        let maStaffNum = resArr.find((item) => item.keyword === "maStaffNum")!;

        maStaffNum.node = (
          <Box className="maStaffNum">
            {res.facilityList?.map((item: any) => (
              <Box key={item.facilityNo} className="tkAdjustCenter">
                <Typography>{`${item.facilityNo}:${item.facilityName}`}</Typography>
                <Typography>{`${item.maStaffNum}人`}</Typography>
              </Box>
            ))}
          </Box>
        );

        let aContractorNo = resArr.find(
          (item) => item.keyword === "aContractorNo"
        )!;
        aContractorNo.text = res.aContractorNo;

        let aCorpName = resArr.find((item) => item.keyword === "aCorpName")!;
        aCorpName.text = res.aCorpName;

        const wfFlg =
          res.latestApplyStatus !== "00" && res.latestApplyStatus !== "16";
        setWorkFlow(wfFlg);
        setStateTableList([...resArr]);
        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const makeHttpObj = (applyEvent: any, formData?: any) => {
    const reqObj: IAPI_APP016_Request = {
      applyEvent,
      contractorNo: businessState.common?.contractorNo,
      reason: memoData,
      applyId: responseData.applyId,
      inquiryCode: memoCheck ? "1" : undefined,
      symbolNo: formData
        ? TkGetCode(CommonOrCommonRetirementFlug, formData.symbolNumberType) +
          "第" +
          (formData.symbolNumber ?? "") +
          "号"
        : undefined,
      decisionDate: formData?.settlementDate,
      screenId: "SCRW050001",
    };

    return reqObj;
  };

  const handleUpdate = async (applyEvent: any, formData?: any) => {
    try {
      const res = await httpAPI_APP016({
        ...makeHttpObj(applyEvent, formData),
      });

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });
        navigate("/SCRW110001");
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const btnEvent = async (btnName: keyof typeof applyEvent) => {
    const event = applyEvent[btnName];
    const eventList = [
      applyEvent["契約者に差戻し"],
      applyEvent["受理"],
      applyEvent["担当者に差戻し"],
      applyEvent["課長代理確認"],
      applyEvent["承認"],
      applyEvent["上長承認"],
      applyEvent["郵送"],
      applyEvent["取下げ"],
    ];

    if (event === applyEvent["承認"]) {
      setIsOpen(true);
    } else if (eventList.includes(event)) {
      handleUpdate(event);
    }
  };

  const onChange = (event: any) => {
    if (event.target.type === "input") {
      setMemoData(event.target.value);
    } else {
      setMemoCheck(event.target.value);
    }
  };

  return (
    <Box className="SCRW050001" data-testid="SCRW050001PageForTest">
      {workFlow && (
        <TkKikoStepper
          applicationFlowType={"TYPE5"}
          businessType={"JOB-02"}
          corporateApplicationClassification={
            responseData.corpApplyKbn as "1" | "other" | undefined
          }
          applicationStatus={
            responseData.latestApplyStatus as ITkViewButtonJudgementStatus
          }
        />
      )}
      <TkInfoManual rule={"\\n"}>{labelids.labelid.LBLW050001_01}</TkInfoManual>
      <TkContractorAndNumberLine
        name="契約者（法人）名"
        no={
          (businessState?.common?.contractorNo ?? "") +
          ":" +
          (businessState?.common?.contractorName ?? "")
        }
      />
      <TkFakeTable
        list={stateTableList}
        ruleSchema={schema}
        showButton={false}
        buttonGroup={[]}
      />

      <TkMemo showTable={true} bodyList={bodyList} onChange={onChange}></TkMemo>
      <TkTableWithNoLine headList={headList} bodyList={fileList} />

      <Box className="btn">
        <TkBackButton className="tkBottonMr" />
        {responseData.latestApplyStatus && workFlow ? (
          <TkViewButtonJudgement
            flowType={"TYPE2"}
            Status={
              responseData.latestApplyStatus as ITkViewButtonJudgementStatus
            }
            onClick={btnEvent}
          />
        ) : (
          <TkButton onClick={() => btnEvent("取下げ")}>取下げ</TkButton>
        )}
      </Box>

      <TkApprovalDateSymbolNumberRegistrationDialog
        data-testid="SCRW050001PageForDialog"
        open={isOpen}
        onSuccess={(data: any) => handleUpdate(applyEvent["承認"], data)}
        onClose={() => setIsOpen(false)}
      />
    </Box>
  );
};

export default SCRW050001;
